
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.566 2.175a1 1 0 01.422.975l-2 13a.998.998 0 01-1.375.769l-3.738-1.553-2.14 2.315A1 1 0 017 17v-2.613a.49.49 0 01.132-.334l5.237-5.716a.5.5 0 00-.7-.71l-6.356 5.648-2.76-1.381A.996.996 0 012 11.028c-.01-.369.185-.713.503-.897l14-8c.335-.19.747-.172 1.063.044z","fill":"#282E3E"}})])
          )
        }
      }
    